import React from 'react';
import { useLocation } from 'react-router';
import { EntityImage } from '@tribeplatform/react-components/common';
import { useRouter } from '@tribeplatform/react-sdk';
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar';
export const LinkMenuBlock = ({ items, title }) => {
    const { Link } = useRouter();
    const location = useLocation();
    if (!items) {
        return null;
    }
    return (React.createElement(NavVertical, null,
        React.createElement(NavVertical.Group, null,
            !!title && React.createElement(NavVertical.GroupHeader, null, title),
            items.map(item => {
                var _a;
                let isActive = false;
                if (item === null || item === void 0 ? void 0 : item.href) {
                    if (item.href === '/') {
                        isActive = (location === null || location === void 0 ? void 0 : location.pathname) === item.href;
                    }
                    else {
                        isActive = ((_a = location === null || location === void 0 ? void 0 : location.pathname) === null || _a === void 0 ? void 0 : _a.indexOf(item === null || item === void 0 ? void 0 : item.href)) === 0;
                    }
                }
                return (React.createElement(NavVertical.Item, { key: item === null || item === void 0 ? void 0 : item.text, variant: "inherit", as: Link, href: item === null || item === void 0 ? void 0 : item.href, target: (item === null || item === void 0 ? void 0 : item.openInNewWindow) ? '_blank' : null, active: isActive, leadingIcon: React.createElement("div", { className: "-ms-1 me-3 w-6 h-6 flex-shrink-0 flex items-center justify-center" },
                        React.createElement(EntityImage, { size: "xs", entity: { image: item === null || item === void 0 ? void 0 : item.image, name: item === null || item === void 0 ? void 0 : item.text } })) }, item === null || item === void 0 ? void 0 : item.text));
            }))));
};
//# sourceMappingURL=Block.js.map